// extracted by mini-css-extract-plugin
module.exports = {"dataContainer":"WordCloudSection_dataContainer__1sskE","thinOptionName":"WordCloudSection_thinOptionName__3k1iA","input":"WordCloudSection_input__3EzuM"};